import {Component, Input} from '@angular/core';

@Component({
  selector: 'greydom-status-indicator',
  templateUrl: './status-indicator.component.html',
})
export class StatusIndicatorComponent {
  @Input() width = '10px';
  @Input() height = '10px';
  @Input() fillColor: string;

  constructor() {
  }
}
